import React from 'react';
import './index.module.less';


interface IProps {
  title: string;
  clickEvent: () => void;
}

const Tips = (props: IProps) => {
  return (
    <div className="flex" styleName="tips" onClick={ props.clickEvent } >
      <i className="iconfont icon-info" />
      <span>{ props.title || '' }</span>
      <i className="iconfont icon-tubiaoyanse" styleName='tips-icon-arrow'/>
    </div>
  )
}

export default Tips;

